import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const SidebarDivider = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"hr">): ReactElement => (
  <hr
    {...props}
    className={clsx(
      className,
      "my-4 border-t border-zinc-950/5 lg:-mx-4 dark:border-white/5",
    )}
  />
);
